import { Helmet } from 'react-helmet';
import {
  AppBar,
  Box,
  Container,
  Grid,
  Tab,
  Tabs,
  Typography
} from '@material-ui/core';
import ClientProfileDetails from 'src/components/client/ClientProfileDetails';
import { useContext, useEffect, useState } from 'react';
import { ClientContext } from 'src/context/ClientContext';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import BranchList from 'src/components/branch/BranchList';
import { BranchContext } from 'src/context/BranchContext';
import OfferList from 'src/components/offer/OfferList';
import { OfferMyProductContext } from 'src/context/OfferMyProductContext';
import { OfferContext } from 'src/context/OfferContext';
import { SubscriptionContext } from 'src/context/SubscriptionContext';
import SubscriptionList from 'src/components/subscription/SubscriptionList';

function TabPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const tab = {
  color: '#FFF'
};

const tabSelected = {
  color: '#FFF',
  borderBottom: '5px solid red'
};

const ClientForm = () => {
  const { id } = useParams();
  const {
    loading,
    client,
    setClient,
    getClient,
    saveClient,
    updateClient,
    loginAsClient,
  } = useContext(ClientContext);

  const { branchs, getBranchs } = useContext(BranchContext);
  const { subscriptions, getSubscriptionsByClient } = useContext(SubscriptionContext);
  const { offerMyProducts, getOfferMyProducts } = useContext(OfferMyProductContext);
  const { offers, getOffers } = useContext(OfferContext);
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(async () => {
    if (id) {
      getClient(id);
      getBranchs(id);
      getOfferMyProducts(id);
      getOffers(id);
      getSubscriptionsByClient(id);
    } else {
      setClient(null);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {`Client | ${process.env.REACT_APP_NAME}`}
        </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth="lg">
          {loading === false
            ? (
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  xs={12}
                >
                  <AppBar position="static">
                    <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                      <Tab style={value === 0 ? tabSelected : tab} label="Dados" {...a11yProps(0)} />
                      <Tab disabled={!client} style={value === 1 ? tabSelected : tab} label="Unidades" {...a11yProps(1)} />
                      <Tab disabled={!client} style={value === 2 ? tabSelected : tab} label="Minhas Ofertas" {...a11yProps(2)} />
                      <Tab disabled={!client} style={value === 3 ? tabSelected : tab} label="Ofertas nos Meus Produtos" {...a11yProps(3)} />
                      <Tab disabled={!client} style={value === 4 ? tabSelected : tab} label="Assinaturas" {...a11yProps(4)} />
                    </Tabs>
                  </AppBar>
                  <TabPanel value={value} index={0} style={{ backgroundColor: '#fff' }}>
                    <ClientProfileDetails
                      client={client}
                      saveform={saveClient}
                      updateform={updateClient}
                      loginAsClient={loginAsClient}
                    />
                  </TabPanel>
                  { id
                    ? (
                      <>
                        <TabPanel value={value} index={1} style={{ backgroundColor: '#fff' }}>
                          <BranchList branchs={branchs} />
                        </TabPanel>
                        <TabPanel value={value} index={2} style={{ backgroundColor: '#fff' }}>
                          <OfferList offers={offers} type="myOffer" />
                        </TabPanel>
                        <TabPanel value={value} index={3} style={{ backgroundColor: '#fff' }}>
                          <OfferList offers={offerMyProducts} type="offerMyProducts" />
                        </TabPanel>
                        <TabPanel value={value} index={4} style={{ backgroundColor: '#fff' }}>
                          <SubscriptionList subscriptions={subscriptions} />
                        </TabPanel>
                      </>
                    )
                    : <></> }
                </Grid>
              </Grid>
            )
            : <></> }
        </Container>
      </Box>
    </>
  );
};
export default ClientForm;
